import TitleHeader from "@/components/TitleHeader";
import { Flex } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import SelectType from "./SelectType";
import { useEffect, useMemo, useState } from "react";
import FillInfo from "./FillInfo";
import {
  createCustomer,
  sendVerificationCode,
  verifyVerificationCode,
} from "@/api/bridge";
import { useUserInfo } from "@/context/UserInfo";
import Email from "./Email";
const CreateKyc = () => {
  const navigate = useNavigate();
  const { bridgeCustomer } = useUserInfo();
  const { handleGetCustomer } = useUserInfo();
  const [selectType, setSelectType] = useState<string>("individual");
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");

  const [email, setEmail] = useState<string>(bridgeCustomer?.email || "");
  const [leageName, setLeageName] = useState<string>("");
  const [step, setStep] = useState<number>(0);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const canConfirm = useMemo((): boolean => {
    if (selectType === "individual") {
      if (!firstName) {
        return false;
      }
      if (!lastName) {
        return false;
      }
    } else {
      if (!leageName) {
        return false;
      }
    }

    if (!email) {
      return false;
    }

    return true;
  }, [firstName, lastName, email, selectType, leageName]);

  const handleSendEmail = async () => {
    const res = await sendVerificationCode({ email });
  };

  const handleVerifyEmail = async (code: string) => {
    try {
      await verifyVerificationCode({ email, code });
      const customer = await handleGetCustomer();
      if (customer.id) {
        navigate("/verifyInfo");
      } else {
        setStep(1);
      }
      return true;
    } catch (error) {
      console.log(error, "error");
      return false;
    }
  };

  const handleResetErrorMessage = () => {
    setErrorMessage("");
  };

  const handleSelectType = (type: string) => {
    setSelectType(type);
    setStep(2);
  };

  const handleLeageName = (value: string) => {
    setLeageName(value);
  };

  const handleFirstName = (value: string) => {
    setFirstName(value);
  };
  const handleLastName = (value: string) => {
    setLastName(value);
  };
  const handleEmail = (value: string) => {
    setEmail(value);
  };

  const handleConfirm = async () => {
    if (!canConfirm) {
      return;
    }
    try {
      const name =
        selectType === "individual" ? `${firstName} ${lastName}` : leageName;
      const res = await createCustomer({
        full_name: name,
        type: selectType,
      });
      await handleGetCustomer();
      navigate("/verifyInfo");
    } catch (error: any) {
      setErrorMessage(error.data.message);
    }
  };

  useEffect(() => {
    if (bridgeCustomer.id) {
      navigate("/verifyInfo");
    } else if (bridgeCustomer?.email) {
      setStep(1);
    }
  }, []);

  return (
    <Flex sx={{ width: "100%", padding: "20px", flexDirection: "column" }}>
      <TitleHeader
        title="Verification"
        color="#D8762B"
        onBack={() => {
          if (step === 0 || step === 1) {
            navigate("/");
          } else {
            setStep(step - 1);
          }
        }}
      />
      {step === 0 && (
        <Email
          onVerify={handleVerifyEmail}
          onSend={handleSendEmail}
          email={email}
          onEmail={handleEmail}
        ></Email>
      )}
      {step === 1 && <SelectType onSelect={handleSelectType}></SelectType>}
      {step === 2 && (
        <FillInfo
          type={selectType}
          firstName={firstName}
          lastName={lastName}
          email={email}
          onFirstName={handleFirstName}
          onLastName={handleLastName}
          onEmail={handleEmail}
          onConfirm={handleConfirm}
          canConfirm={canConfirm}
          leageName={leageName}
          onLeageName={handleLeageName}
          errorMessage={errorMessage}
          onResetErrorMessage={handleResetErrorMessage}
        ></FillInfo>
      )}
    </Flex>
  );
};

export default CreateKyc;
